var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEndCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#FF0000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_125_1811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.54166 23.6047L7.42034 21.4834C7.22261 21.2873 7.06802 21.052 6.96648 20.7927C6.86493 20.5333 6.81867 20.2557 6.83065 19.9774C6.84264 19.6992 6.9126 19.4265 7.03606 19.1768C7.15952 18.9272 7.33376 18.7061 7.54762 18.5277C9.95993 16.5882 12.7935 15.2417 15.8208 14.5962C18.6149 13.9733 21.5119 13.9733 24.3061 14.5962C27.3458 15.2458 30.1897 16.6024 32.6075 18.556C32.8207 18.7338 32.9945 18.9542 33.1179 19.2029C33.2413 19.4516 33.3116 19.7233 33.3242 20.0007C33.3369 20.2781 33.2916 20.555 33.1913 20.814C33.0911 21.0729 32.938 21.3081 32.7418 21.5046L30.6205 23.6259C30.2807 23.9725 29.8265 24.1836 29.3426 24.2201C28.8586 24.2565 28.3779 24.1157 27.9901 23.8239C27.2217 23.2346 26.3891 22.7341 25.5081 22.3319C25.1599 22.174 24.8643 21.9195 24.6562 21.5987C24.4482 21.2778 24.3365 20.9041 24.3343 20.5217V20.2499C24.3343 19.3496 23.7345 18.5471 22.8476 18.3921C21.0242 18.0732 19.1591 18.0732 17.3358 18.3921C16.4489 18.5471 15.8491 19.3496 15.8491 20.2499V20.5217C15.8469 20.9041 15.7352 21.2778 15.5272 21.5987C15.3191 21.9195 15.0235 22.174 14.6753 22.3319C13.7943 22.7341 12.9617 23.2346 12.1933 23.8239C11.8014 24.119 11.3147 24.2596 10.8257 24.2192C10.3368 24.1788 9.87984 23.9601 9.54166 23.6047Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_125_1811",
    x: 4.8288,
    y: 13.129,
    width: 30.4975,
    height: 14.097,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_125_1811"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_125_1811",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndCall);
export default __webpack_public_path__ + "static/media/end_call.bab88d6551dac93b215f65cea5c85205.svg";
export { ForwardRef as ReactComponent };